import { AccountApiKeyServiceData } from 'services/Account/APIKeys/apiKeysType';
import { SortParams } from 'types/common/sorting';
import { FetchAction } from 'types/services/redux-action';
import { FetchReducer, SortState } from 'types/services/redux-state';

export const FETCH_API_KEYS_IS_COMPLETE = 'FETCH_API_KEYS';

export const FETCH_API_KEYS_IS_PENDING = 'FETCH_API_KEYS_IS_PENDING';

export const FETCH_API_KEYS_IS_ERROR = 'FETCH_API_KEYS_IS_ERROR';

export const CREATE_API_KEYS_COMPLETE = 'CREATE_API_KEYS';

export const CREATE_API_KEYS_IS_PENDING = 'CREATE_API_KEYS_IS_PENDING';

export const CREATE_API_KEYS_IS_ERROR = 'CREATE_API_KEYS_IS_ERROR';

export const EDIT_API_KEYS_COMPLETE = 'EDIT_API_KEYS';

export const EDIT_API_KEYS_IS_PENDING = 'EDIT_API_KEYS_IS_PENDING';

export const EDIT_API_KEYS_IS_ERROR = 'EDIT_API_KEYS_IS_ERROR';

export const DELETE_API_KEYS_COMPLETE = 'DELETE_API_KEYS';

export const DELETE_API_KEYS_IS_PENDING = 'DELETE_API_KEYS_IS_PENDING';

export const DELETE_API_KEYS_IS_ERROR = 'DELETE_API_KEYS_IS_ERROR';

export const SORT = 'SORT_API_KEYS';

export type ApiKeysReducerState = { apiKeys: AccountApiKeyServiceData[] } & FetchReducer<'fetch' | 'create' | 'edit' | 'delete'> &
  SortState<AccountApiKeyServiceData>;

export type ApiKeysActions =
  | FetchAction<'FETCH_API_KEYS', AccountApiKeyServiceData[]>
  | FetchAction<'CREATE_API_KEYS', AccountApiKeyServiceData>
  | FetchAction<'EDIT_API_KEYS', AccountApiKeyServiceData>
  | FetchAction<'DELETE_API_KEYS', AccountApiKeyServiceData['id']>
  | { type: 'SORT_API_KEYS'; params: SortParams<AccountApiKeyServiceData> };
